module.exports = __webpack_public_path__ + "img/code.f4fb99e9.svg";